<template>
  <div class="collectionDetail">
    <div v-if="loading" class="loading">
      <adx-loading />
    </div>
    <div v-if="!loading" class="collectionDetail__left">
      <div class="collectionDetail__left__image">
        <img class="image" :src="item.squareImage" alt="">
        <p class="total">Total Listing {{item.itemCount}} Items</p>
      </div>
      <div class="collectionDetail__left__description">
        <p>{{item.description}}</p>
      </div>
      <div class="collectionDetail__left__action">
        <button class="btn-regular primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <div v-if="!loading" class="collectionDetail__right">
      <div class="collectionDetail__right__title">
        <h1 class="medium-title">{{item.title | capitalizing}}</h1>
      </div>
      <div class="collectionDetail__right__filter">
        <adx-dropdown-list class="" @selected="selected" :list="list" labelButton="Categories" />
      </div>
      <div class="collectionDetail__right__listing">
        <template>
          <adx-detail-list v-for="(category, index) in filteredDevices" :key="index"
          @createNew="createNew" @createNewCampaign="createNewCampaign"
          :title="category.title" :items="category.items" :headers="headers"
          :count="category.count" :menuList="menuList" :category="category.cat"/>
        </template>
      </div>
    </div>
    <adx-modal v-if="isShownCampaign" :noTitle="isMobile == false" :noTitleTop="isMobile == true" @modal-close="isShownCampaign = false" :type="!isMobile ? 'small' : ''">
      <div class="collectionDetail__campaign" slot="content">
        <h2 class="small-title">Add to campaign</h2>
        <button class="btn-block primary" @click="createCampaignUntitled">
          Create new campaign
          <div class="primary__load">
            <adx-loading-spin v-if="isCreateCampaignLoad" slot="loading"/>
          </div>
        </button>
        <div class="collectionDetail__campaign__break">
          <span>OR</span>
        </div>
        <h2 class="small-title">Add to current campaign</h2>
        <div class="load">
          <adx-loading v-if="isLoadingCampaign" slot="loading" />
        </div>
        <ul class="collectionDetail__campaign__list">
          <li v-for="(item, index) in campaigns" :key="index" @click="appendCampaign(item.id)" class="collectionDetail__campaign__list__item">
            <p> {{item.title}} </p>
            <div class="collectionDetail__campaign__list__item__load">
              <adx-loading-spin-red v-if="isLoadingAppend.includes(item.id)" slot="loading"/>
            </div>
          </li>
        </ul>
      </div>
    </adx-modal>
    <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="toggleModalCreate" type='small' :noTitle="true">
      <div class="collectionDetail__modal" slot="content">
        <div class="collectionDetail__modal__input">
          <input ref="input" type="text" @keyup="KeyUp">
          <label class="subhead">Folder Name</label>
        </div>
        <div class="collectionDetail__modal__buttons">
          <button class="btn-regular secondary" @click="toggleModalCreate">Cancel</button>
          <button class="btn-regular primary" :disabled="newTitle === ''"
          @click="createFolder">Save</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
      <div class="collectionDetail__modal" slot="content">
        <div class="collectionDetail__modal__input">
          <input ref="input" type="text" @keyup="KeyUpCampaign">
          <label class="subhead">Campaign Name</label>
        </div>
        <div class="collectionDetail__modal__buttons">
          <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
          <button class="btn-regular primary" :disabled="newTitle === ''"
          @click="createCampaign">Save</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DropdownList from '@/components/Dropdown/ListDropdown'
import DetailList from '@/views/Collection/CollectionDetail/DetailList'
import Modal from '@/components/Modal'
import Loading from '@/components/Loading/Primary'
import LoadingSpinRed from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-collection-detail',
  components: {
    'adx-dropdown-list': DropdownList,
    'adx-detail-list': DetailList,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-loading-spin-red': LoadingSpinRed,
  },
  props: {

  },
  data() {
    return {
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isCreateCampaignLoad: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      items: [],
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      list: [
      ],
      item: {
        title: '',
        description: '',
        itemCount: 0,
        squareImage: '/img/notfound/img-placeholder_square.jpg'
      },
      menuList: [],
      selectedCategory: null,
      deviceLists: [],
      allDeviceLists: [],
      loading: true,
      isCreateSaved: false,
      isCreateCampaign: false,
      createParams: {},
      newTitle: '',
    }
  },
  computed: {
    filteredDevices() {
      if (this.selectedCategory) {
        let device = this.deviceLists.filter((category) => {
          return category.cat == this.selectedCategory
        })

        return device
      }

      return this.deviceLists
    },
    ...mapGetters ({
      token: 'token'
    }),
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
    this.loadDataDevice()
    this.loadSavedandCampaign()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    toggleModalCreate() {
      this.isCreateSaved = !this.isCreateSaved
    },
    createNewCampaign(params) {
      this.createParams = params
      if (this.token) {
        this.isCreateCampaign = true
      } else {
        const currentRoute = this.$route.path
        this.$router.push({name: 'signin', query: { next: currentRoute }})
      }
    },
    createNew(params) {
      this.createParams = params
      if (this.token) {
        this.isCreateSaved = true
      } else {
        const currentRoute = this.$route.path
        this.$router.push({name: 'signin', query: { next: currentRoute }})
      }
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.$notify({
            group: 'saved',
            title: 'Added to saved',
            text: 'this item has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    showCampaign(){
      this.isShownCampaign = true
      this.getCampaigns()
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            this.campaigns = response.data
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    appendCampaign(id) {
      if (this.isLoadingAppend.length == 0) {
        (async () => {
          this.isLoadingAppend.push(id)
          const data = {
            channel_name: 'collection',
            list_channel_id: [this.$route.params.id]
          }
          const response = await api.patch(apiV2.campaignAddBulkListing(id), data, { needToken: true })
          this.isLoadingAppend = []
          if (response.status == 200) {
            this.$router.push({ path: `/${id}/campaign-editor` })
          } else {
            this.error = response.data.error
          }
        })();
      }
    },
    createCampaignUntitled() {
      (async () => {
        if (this.token) {
          this.isCreateCampaignLoad = true
          const data = {
            campaign_channel: [
              {
                name: 'collection',
                list_id: [this.$route.params.id]
              }
            ]
          };
          const response = await api.post(apiV2.campaignNew, data, { needToken: true })
          this.isCreateCampaignLoad = false
          if (response.status == 201) {
            let newCampaign = true
            this.$router.push({ name: 'campaigneditorpage', params: { id: response.data['data']['id'], newCampaign: newCampaign }})
            this.loadSavedandCampaign()
          } else {
            this.error = response.data.error
          }
        } else {
          const currentRoute = this.$route.path
          this.$router.push({name: 'signin', query: { next: currentRoute }})
        }
      })();
    },
    loadSavedandCampaign() {
      while(this.menuList.length > 0) {
        this.menuList.pop()
      }
      this.menuList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        if (this.token) {
          const response = await api.get(apiV2.saved, { needToken: true })
          if (response.status === 200) {
            const { data } = response
            data.map(el => {
              this.menuList[0]['items'].push({
                "name": el.title,
                "value": el.id
              })
            })
          }
        }
      })();
    },
    loadCampaigns() {
      (async () => {
        if (this.token) {
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          if (response.status == 200) {
            const { data } = response
            data.map(el => {
              this.menuList[1]['items'].push({
                "name": el.title,
                "value": el.id
              })
            })
          } else {
            // this.error = response.data.error
          }
        }
      })();
    },
    loadData() {
      (async () => {
        this.loading = true
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionDetailPublic(id))
        this.item.title = data.title
        this.item.description = data.description
        this.item.itemCount = data.item_count
        this.item.squareImage = data.square_image
        this.loading = false
      })();
    },
    loadDataDevice() {
      (async () => {
        this.loading = true
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionSelectedDevice(id))
        this.allDeviceLists = data
        this.mappingSelectedDevices()
        this.loading = false
        // this.item.title = data.title
        // this.item.description = data.description
        // this.item.itemCount = data.item_count
        // this.item.squareImage = data.square_image
      })();
    },
    mappingSelectedDevices (category=null) {
      let list = this.allDeviceLists
      this.deviceLists = []
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          if (category) {
            if (category == key) {
              this.deviceLists.push({
                title: key.charAt(0).toUpperCase() + key.substr(1),
                items: list[key],
                count: list[key].length,
                cat: key
              })
              this.list.push({
                id: index,
                label: key.charAt(0).toUpperCase() + key.substr(1),
                value: key
              })
            }
          } else {
            this.deviceLists.push({
              title: key.charAt(0).toUpperCase() + key.substr(1),
              items: list[key],
              count: list[key].length,
              cat: key
            })
            this.list.push({
              id: index,
              label: key.charAt(0).toUpperCase() + key.substr(1),
              value: key
            })
          }
        }
      })
    },
    selected(item) {
      this.selectedCategory = item.value
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>